import { jsx, jsxs } from "react/jsx-runtime";
function CoverPage({ bookTitle, bookLabel, grade, pageWidth, pageHeight }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "print-page",
      style: {
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
        width: pageWidth,
        height: pageHeight,
        background: "#ffffff"
      },
      children: /* @__PURE__ */ jsxs("div", { style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        padding: 60,
        gap: 16
      }, children: [
        grade && /* @__PURE__ */ jsx("span", { style: { fontSize: 16, color: "#6B7280", fontWeight: 500 }, children: grade }),
        /* @__PURE__ */ jsx("h1", { className: "font-dunggeunmiso", style: {
          fontSize: 36,
          color: "#2B3B7A",
          fontWeight: 700,
          textAlign: "center"
        }, children: bookTitle || "속표지" }),
        bookLabel && /* @__PURE__ */ jsx("span", { style: { fontSize: 18, color: "#9CA3AF", fontWeight: 600, marginTop: 8 }, children: bookLabel })
      ] })
    }
  );
}
export {
  CoverPage
};
//# sourceMappingURL=CoverPage.js.map
